import { Spin } from 'antd';
import React from 'react';

const E12Spinner = ({ className }: { className?: string }) => {
  return (
    <div
      className={`flex flex-1 w-full items-center justify-center h-full mt-60 ${className}`}
    >
      <Spin size="large" />
    </div>
  );
};

export default E12Spinner;
